exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#arch.hidden,#arch.landscape{display:none;opacity:0;visibility:hidden}#arch.portrait{bottom:60px;height:20%;position:absolute;width:100%;z-index:-1}", ""]);

// exports
exports.locals = {
	"arch": "arch",
	"hidden": "hidden",
	"landscape": "landscape",
	"portrait": "portrait"
};